// extracted by mini-css-extract-plugin
module.exports = {"container":"_1410bfd27b--container--daQ00","slide":"_1410bfd27b--slide--pHepQ"};